import { View, Text } from 'react-native';
import { useRouter } from 'expo-router';
import { useTranslation } from '@dramadetector/shared';
import { TierBody, TierButton } from '@dramadetector/ui';
import { GlassCard } from '../../../components/glass';
import { captureEvent } from '../../../lib/analytics';

export function AnonCTASection() {
  const { t } = useTranslation('settings', { useSuspense: false });
  const router = useRouter();

  const onPress = () => {
    captureEvent('Anon_Settings_CtaClicked', { source: 'settings' });
    router.push('/(auth)/signup?source=anon_settings');
  };

  return (
    <View className="mt-4">
      <TierBody
        size="xs"
        weight="semibold"
        className="text-gray-500 uppercase px-4 mb-2"
      >
        {t('anon.section_label' as never)}
      </TierBody>
      <GlassCard>
        <Text
          style={{
            fontWeight: '600',
            color: '#111827',
            marginBottom: 6,
            textAlign: 'center',
          }}
        >
          {t('anon.cta.headline' as never)}
        </Text>
        <Text
          style={{
            color: '#4b5563',
            fontSize: 14,
            marginBottom: 16,
            textAlign: 'center',
          }}
        >
          {t('anon.cta.body' as never)}
        </Text>
        <TierButton
          variant="primary"
          size="md"
          fullWidth
          onPress={onPress}
          testID="settings-anon-cta"
        >
          {t('anon.cta.button' as never)}
        </TierButton>
      </GlassCard>
    </View>
  );
}
